// src/components/Vitruta.js
import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';

/* -------------------
   Global fonts
   ------------------- */
const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'AnybodyMedium';
    src: url('../assets/fonts/Anybody-Medium.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  /* new — ultra-bold cut for hero + footer */
  @font-face {
    font-family: 'AnybodyBlack';
    src: url('../assets/fonts/Anybody-Black.ttf') format('truetype');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }
`;

/* -------------------
   Breakpoints
   ------------------- */
const breakpoints = {
  mobile: '40rem',
  tablet: '64rem',
};

/* -------------------
   Base layout
   ------------------- */
const Page = styled.article`
  max-width: 110rem;
  margin: 0 auto;
  background: #fff;
  font-family: 'AnybodyMedium', 'Anybody', sans-serif;
  color: #000;
  overflow-x: hidden;
`;

/* -------------------
   Hero
   ------------------- */

const HeroContent = styled.div`
  position: absolute;
  top: 50%;                  /* adjust as needed */
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(0.5rem, 1.5vw, 2rem);
  width: 95%;
`;
const HeroSection = styled.section`
  position: relative;
  width: 100%;
`;

const HeroImg = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const HeroHeadline = styled.h1`
  font-family: 'AnybodyBlack', 'Anybody', sans-serif;
  font-size: clamp(3rem, 8vw, 8rem);
  font-weight: 900;
  line-height: 1.1;
  color: #fff;
  text-align: center;
  margin: 0;

  /* Для экранов уже 40rem (640px) и меньше уменьшить заголовок */
  @media (max-width: ${breakpoints.mobile}) {
    font-size: clamp(2rem, 6vw, 4rem);
  }
`;

const Byline = styled.p`
  /* убрали абсолютное позиционирование */
  font-size: clamp(0.5rem, 1vw, 1.3rem);
  color: #fff;
  text-align: center;
  font-weight: 400;
  letter-spacing: 0.05em;
  margin: 0;
`;

const HeroText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(0.5rem, 2vw, 2rem);
  width: 90%;
`;
const MenuButton = styled.button`
  position: absolute;
  top: 1.5rem;
  left: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  background: transparent;
  border: none;
  cursor: pointer;

  span {
    display: block;
    width: 3rem;
    height: 0.25rem;
    background: #fff;
  }
`;

/* -------------------
   Text styles
   ------------------- */
const Credit = styled.p`
  font-size: clamp(0.75rem, 1vw, 1.5rem);
  max-width: 100ch;
  margin: 1rem auto;
  font-weight: 700;
  text-align: center;

  span {
    text-decoration: underline;
  }
`;

const Lead = styled.h2`
  font-size: clamp(1.5rem, 2.1vw, 2.5rem);
  max-width: 80ch;
  margin: 2rem auto;
  text-align: center;
  font-weight: 700;
`;

const Para = styled.p`
  font-size: clamp(1rem, 1.6vw, 1.5625rem);
  line-height: 1.38;
  max-width: 80ch;
  margin: 1rem auto;
  text-align: center;
`;

/* -------------------
   Content Sections
   ------------------- */
const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  margin: 4rem 0;

  /* new — left / right breathing room */
  padding-inline: clamp(1rem, 4vw, 2rem);

  @media (min-width: ${breakpoints.tablet}) {
    flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
    gap: 4rem;
  }
`;

const SectionImg = styled.img`
  width: 100%;
  height: auto;
  flex: 1 1 50%;
  max-width: 40rem;
`;

const TextBlock = styled.div`
  flex: 1 1 50%;
`;

/* -------------------
   Spotify iframe
   ------------------- */
const SpotifyFrame = styled.iframe`
  display: block;
  border-radius: 0.75rem;
  width: 100%;
  height: 22rem;
  max-width: 80rem;
  margin: 3rem auto;
  border: none;
`;

/* -------------------
   Footer
   ------------------- */
const FooterBar = styled.footer`
  background: #000;
  padding: clamp(3rem, 1vh, 3rem) 0;
  text-align: center;

  h1 {
    font-family: 'AnybodyBlack', 'Anybody', sans-serif;  /* <- changed */
    color: #fff;
    font-size: clamp(2.6rem, 8vw, 8rem);
    font-weight: 900;
    margin: 0;
    line-height: 1;
  }
`;

const Slogan = styled.h3`
  font-size: clamp(1.25rem, 1.8vw, 2rem);
  font-weight: 700;
  max-width: 80ch;
  text-align: center;
  margin: 4rem auto 2rem;
`;


/* ===============================================================
   Component
   =============================================================== */
export default function Vitruta() {
  return (
    <Page>
      <GlobalStyles />

      {/* Hero */}
      <HeroSection>
        <HeroImg src="/assets/vitruta2.png" alt="Vitruta flagship store in London" />
        <HeroText>
       <HeroHeadline>
  CAN I HELP YOU?<br/>
  YEAH, WHAT’S<br/>
  THIS TRACK?
</HeroHeadline>
<Byline>WORDS BY GABRIEL MEALOR‑PRITCHARD</Byline>
</HeroText>
      </HeroSection>

      <Credit>
        Photographed by <span>Benoit Florençon</span>, a Paris-based architecture &amp; design photographer
      </Credit>
      <br />
      <br />
      {/* Intro */}
      <Lead>
        HAVE YOU EVER WANDERED INTO A STORE AND STOPPED TO SHAZAM THE TUNE THEY HAVE BLARING THROUGH THE SPEAKERS? GO ON, PUT
        YOUR HAND UP, OURS IS TOO! GABRIEL MEALOR-PRITCHARD TALKS TO TWO SOUND CURATORS WHO HAVE PUT THEIR HANDS TO COMPILING
        A SELECTION OF TUNES THAT ENHANCE THE STORE EXPERIENCE.
      </Lead>

      {/* SECTION 1 */}
      <Section>
        <SectionImg src="/assets/vitruta1.png" alt="Inside vitruta store" />
        <TextBlock>
          <Para>
          Riff Magazine focuses on the intersection of fashion and music, through the lens of fashion shows, exhibitions, nightclubs and more. Though there is one other integral location where the two blend seamlessly, and that is in-store. As the standout arena for music and fashion, retail spaces not only define the vibe of the label in question but also directly influence the buying habits of the customer as they subliminally soak up the soundtracks. This is why, when you enter various stores, you'll begin to understand their significant soundtracks, and the association between designs and purpose becomes a natural process. There has been a recent surge in social media posts that poke fun at how, when a retail assistant approaches, rather than asking for help with the garments, customers ask, "What is this track?" Or "Yeah, a Red Bull and Coke please!" So it begs the question: have these fashion stores become the latest place to find new tunes? 
          At vitruta, an innovative Turkish lifestyle store born out of Istanbul, recently opened its London flagship in Kings Cross - and in doing so, requested sound curators, Ulya Soley and Can Aksan, to envision the soundscape of the brand's latest venture.
          </Para>
        </TextBlock>
      </Section>

      {/* embed under Section 1 */}
      <SpotifyFrame
        src="https://open.spotify.com/embed/track/1Q5gLviX2Nw6915iO9WewZ?utm_source=generator"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
      />

      {/* SECTION 2 — text left, photo right  */}
      <Section>
        <TextBlock>
          <Para>
          Curator and publications editor at the Pera Museum, Ulya Soley, attended Central Saint Martins to study an MA in Culture, Criticism, and Curation before being chosen by vitruta's creative director, Serra Duran Paralı, to build a unique soundscape for the shopping space. "When creating a playlist, I prioritise authenticity and personal taste. I choose tracks that feel meaningful to me and align with the atmosphere I want to create," says Soley, honing in on how she puts originality at the forefront of her process.
          </Para>
          <SpotifyFrame
        src="https://open.spotify.com/embed/track/3tuhSQmq8ZIcYuiuRLjNG8?utm_source=generator"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
      />
        </TextBlock>
        <SectionImg src="/assets/vitruta3.png" alt="Curator Ulya Soley" />
      </Section>

      {/* SECTION 3 */}
      <Section>
        <SectionImg src="/assets/vitruta4.png" alt="Sound artist Can Aksan" />
        <TextBlock>
          <Para>
              Aksan, an architecture student turned music artist, has researched the "relationship between form, sound and landscape," as stated in his online biography. The Turkish creative explains, "The sounds play an integral part in the shopping experience. Whether it is acoustics or a well-curated playlist, it sets the atmosphere and character for the location. The criteria must be selecting the right tunes that fit the brand identity and values shaped by the brand." Botanically inspired Aēsop, for example, opt for a more spiritual and relaxing approach to music, whereas the more fast-paced fashion stores like Zara choose pulsating electronic songs above all else. A carefully curated in-store soundtrack becomes an extension of a brand’s identity or narrative. "Brands like Apple have skilfully used music to reflect their minimalist and innovative identities. The right playlist can enhance the brand’s narrative, making it feel more cohesive and memorable," Soley explains. "It’s important to curate a mix of different genres and tempos that flows naturally without overwhelming the environment, offering a cohesive soundscape that feels organic and engaging," she adds.
          </Para>
        </TextBlock>
      </Section>

      {/* embed under Section 3 */}
      <SpotifyFrame
        src="https://open.spotify.com/embed/track/5AJFzzHaJSiog0iU61haCF?utm_source=generator"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
      />

      {/* SECTION 4 — text left, photo right */}
      <Section>
        <TextBlock>
          <Para>
          In Aksan's view, "The soundtrack carries a weight and a purpose when carefully selected, and when aligned together, it creates a sonic landscape, which is a narrative by itself." For him, it's about telling a story with the music, asserting that the music "sits inside the store's architecture and becomes part of the storytelling." Music is not merely background noise, but is an active element which is intentionally articulated and in place to shape customer experience. Just as lighting and spatial design craft a visual journey, the unique soundtrack resonates not only within the walls of the shop but in the client's memory as well.
          In terms of their work for vitruta, Soley and Aksan both spoke on what music genre sprang to mind as they embarked on their sonic task. "When thinking of virtuta, I immediately thought of electronic music, which has a unique atmosphere that fits the brand's visual identity. I thought of a beat which is textural and mellow yet danceable," describes Aksan, with Soley adding that, "I envisioned a mix of ambient electronic and subtle indie genres. I tried to pick songs that evoke affect." Both falling onto a similar wavelength, it was the futuristic interior decoration which conveyed these intentions. "It is influenced by the brand's interior design, which is carefully designed through industrial materials such as metal. Also, having a speaker inside the showroom gives an idea of being inside a club," says Aksan.
          </Para>
        </TextBlock>
        <SectionImg src="/assets/vitruta5.png" alt="Vitruta futuristic interior" />
      </Section>

      {/* embed under Section 4 */}
      <SpotifyFrame
        src="https://open.spotify.com/embed/track/4XXfQ8fBHMIgcygY4hV6RC?utm_source=generator" 
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
      />

      {/* SECTION 5 */}
      <Section>
        <SectionImg src="/assets/vitruta6.png" alt="Shoppers enjoying music at vitruta" />
        <TextBlock>
          <Para>
          It's been said that the music in stores influences buying habits, more energising tunes lift client spirits and more sales are made on average. It was explored by Amir Manzoor for SageJournals that "consumers pleased with the shopping environment tend to exhibit impulse buying behaviour." A key point is that the environment the customers find themselves within must be replicated through the ambience they immerse themselves with; in other words, the store should play music that reflects the motivations of the clients. Aksan states, "You want to own the curation behind it, and you want to be part of something larger than yourself," whereas on the other hand, Soley talks about how her approach is "more about creating an atmosphere that reflects my personal taste and enhances the overall experience in the store. Music for me is a way to build a mood, not necessarily to influence purchasing decisions." For her, the number in sales is not her top priority, she takes a personal edge to deciphering which music she will add to her playlists.
          </Para>
        </TextBlock>
      </Section>

      {/* embed under Section 5 */}
      <SpotifyFrame
        src="https://open.spotify.com/embed/track/6zcvPipvqDarQkSmL3CXnH?utm_source=generator"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
      />
<Para>
On the flip side of this, we asked these two creatives about a time when they were put off by a space due to the music being played. As Aksan explained, "a space which has no identity or a specific story is enough to tell you that there is nothing valuable there." Soley adds that "If the music is uncomfortable or doesn’t align with the environment, it can detract from the experience," leading us back to our original point that sounds must reflect the emotional energy of the customer base. "A dissonant or overly intrusive playlist can make it hard to enjoy being in the space, and I might decide to leave if the atmosphere feels off," Soley includes.\nAn obvious example of this is at Christmas time. We hear the same songs on loop, though, this being said, it is all for a reason... but subconsciously, you cannot get the festive rhythms out of your head.
<br/>
<br/>
So, next time you peruse the rails of a showroom and catch yourself bobbing your head or pulling out your phone to Shazam the track, take a second to take in what else has been curated for your overall experience. It shows the brand's care, that they believe in their story, and reminds you that none of it is accidental. As Soley and Aksan tell us, soundscapes aren't just the labels sticking on their favourite tunes, they are subtle scripts to guide your emotional journey through the world they have curated. Their identity is constructed through sound and other atmospheric details. Whether the company's intention is to spark a purchase or not, it's clear that what we hear and feel can shape our buying habits and recollection of the time we have had in that specific location... on top of what we might be taking home with us. Retail, it seems, has never sounded so good.
</Para>
      {/* Kick-out slogan + playlist */}
      <Slogan>
        INDULGE IN THE CLUB RIFF PLAYLIST FROM OUR LAUNCH EVENT HELD AT VITRUTA AND MIXED LIVE BY THEO THOMPSON BELOW!
      </Slogan>

      <SpotifyFrame
        src="https://open.spotify.com/embed/playlist/2SJv8Pk7nQ40OZ1bQlX42q?utm_source=generator&theme=0"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
      />

      {/* Footer */}
      <FooterBar>
        <h1>RIFF MAGAZINE</h1>
      </FooterBar>
    </Page>
  );
}
